import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

const useClasses = makeStyles((theme) => ({
	buttonGroup: {
		display: 'flex',
		wrap: 'nowrap',
		width: '100%',
		'&>*': {
			flex: '1 0 50%',
		},
		border: `2px solid ${theme.palette.grey[50]}`,
	},

	button: {},

	// styles for non-selected buttons
	nonSelected: {
		'&.MuiButton-contained': {
			backgroundColor: `${
				theme.palette.gray?.colorGray30 || '#d0d0d0'
			} !important`,
			color: `${theme.palette.text?.secondary || '#000000'} !important`,
			borderColor: theme.palette.gray?.colorGray30 || '#d0d0d0',
		},

		'&.MuiButton-contained:hover': {
			backgroundColor: `${
				theme.palette.gray?.colorGray40 || '#c0c0c0'
			} !important`,
		},
	},
}));

function ToggleButton({ buttons, onChange, value, ...props }) {
	const classes = useClasses();

	return (
		<ButtonGroup {...props} className={classes.buttonGroup}>
			{buttons.map(({ label, value: _value }) => (
				<Button
					key={_value}
					variant="contained"
					size="large"
					fullWidth
					role="button"
					data-testid={label}
					aria-label={label}
					className={`${classes.button} ${
						_value === value ? '' : classes.nonSelected
					}`}
					onClick={() => onChange(_value)}
				>
					{label}
				</Button>
			))}
		</ButtonGroup>
	);
}

ToggleButton.propTypes = {
	buttons: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.any.isRequired,
};

export default ToggleButton;
